import { useEffect, useState } from 'react'
import { idText } from 'typescript'

export default function useBalanceUpdate(
  stateRound: {
    balance: string
    balancebefore: string
    totalWin: string
    state: number
  },
  showResult: boolean,
): string {
  const [finalBalance, setFinalBalance] = useState<string>(stateRound.balance)
  const [afterBalance, setAfterBalance] = useState<string>(stateRound.balance)
  const [beforeBalance, setBeforeBalance] = useState<string>(
    stateRound.balancebefore,
  )

  useEffect(() => {
    setFinalBalance(stateRound.balance)
  }, [stateRound.balance])

  useEffect(() => {
    setAfterBalance(stateRound.balance)
    setBeforeBalance(stateRound.balancebefore)
  }, [stateRound])

  useEffect(() => {
    if (+stateRound.totalWin > 0) {
      setFinalBalance(beforeBalance)
    } else {
      setFinalBalance(afterBalance)
    }
  }, [afterBalance, beforeBalance])

  useEffect(() => {
    if (showResult) {
      switch (stateRound.state) {
        case 5:
        case 11:
          setTimeout(() => {
            setFinalBalance(afterBalance)
          }, 200)
          break

        default:
          setFinalBalance(afterBalance)
          break
      }
    }
  }, [showResult])

  return finalBalance
}
